// src/components/maintenance/adminAuth.js
// Central place for the admin token. Uses sessionStorage: the unlock
// persists across refreshes within a tab, and clears when the tab closes.

const TOKEN_KEY = "rw_admin_token";

export const saveAdminToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
